import { render } from "./pdfView.vue?vue&type=template&id=c2593682&scoped=true"
import script from "./pdfView.vue?vue&type=script&lang=js"
export * from "./pdfView.vue?vue&type=script&lang=js"

import "./pdfView.vue?vue&type=style&index=0&id=c2593682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2593682"]])

export default __exports__